import { createIcon } from '@chakra-ui/icons';

export const ViewFilled = createIcon({
  displayName: 'ViewFilled',
  viewBox: '0 0 24 17',
  d: 'M12 0C6.54545 0 1.88727 3.39273 0 8.18182C1.88727 12.9709 6.54545 16.3636 12 16.3636C17.4545 16.3636 22.1127 12.9709 24 8.18182C22.1127 3.39273 17.4545 0 12 0ZM12 13.6364C8.98909 13.6364 6.54545 11.1927 6.54545 8.18182C6.54545 5.17091 8.98909 2.72727 12 2.72727C15.0109 2.72727 17.4545 5.17091 17.4545 8.18182C17.4545 11.1927 15.0109 13.6364 12 13.6364ZM12 4.90909C10.1891 4.90909 8.72727 6.37091 8.72727 8.18182C8.72727 9.99273 10.1891 11.4545 12 11.4545C13.8109 11.4545 15.2727 9.99273 15.2727 8.18182C15.2727 6.37091 13.8109 4.90909 12 4.90909Z',
});
